import { AuditUpdatesMessage } from "Types";
import { ExportJobsResponse } from "../types";

export const updateExportJob = (
  draft: ExportJobsResponse,
  message: AuditUpdatesMessage,
): ExportJobsResponse => {
  if (message.action !== "updated") {
    return draft;
  }

  return {
    match_count: draft.match_count,
    jobs: draft.jobs.map((exportJob) => {
      if (message.data.id === exportJob.id) {
        return message.data;
      } else {
        return exportJob;
      }
    }),
  };
};
